import React, { useEffect, useState, useContext } from 'react'
import { useTranslation } from 'react-i18next'

import { API__ANALYTICS } from 'api'

import Modal from 'components/Modal/Modal'
import Loader from 'components/Loader/Loader'
import Pagination from 'components/Pagination/Pagination'

import { REWARD_DATA } from 'pages/Editor/Tabs/Editor/Modals/RewardsModal/components/Reward/constants'

import AnalyticsContext from '../../../../analyticsContext'

import { getStatus } from '../../utils'
import { STATUS } from '../../constants'

import Blocks from './components/Blocks/Blocks'
import Block from './components/Block/Block'
import BlockItem from './components/BlockItem/BlockItem'

import styles from './Details.module.scss'

const Details = ({ reward, onClose }) => {
    const { t } = useTranslation()
    const {
        projectProjection: { projectId, rewards: rewardsProjection },
    } = useContext(AnalyticsContext)
    const [winners, setWinners] = useState(null)
    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        fetchData()
    }, [])

    const getVisibilityText = () => {
        const status = getStatus(reward)
        if (status === STATUS.AVAILABLE) return t('available')
        if (status === STATUS.OUT_OF_STOCK) return t('out of stock')
        if (status === STATUS.DELETED) return t('deleted')
        return null
    }

    async function fetchData(page = 0) {
        try {
            setIsLoading(true)
            const data = await API__ANALYTICS.GET_PROJECT_PRIZE_DETAILS({
                projectId,
                drawId: rewardsProjection.prizeDrawExternalKey,
                prizeId: reward.id,
                params: {
                    size: 10,
                    page,
                    sort: 'created,desc',
                },
            })
            setWinners(data)
        } catch (err) {
            console.error(err)
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <>
            <Modal isShowCloseIcon onClose={onClose}>
                <div className={styles.details}>
                    <h2 className={styles.header}>{reward.name}</h2>
                    <div className={styles.content}>
                        <Blocks>
                            <Block title={t('Summary')}>
                                <BlockItem name={t('Name')} value={reward.name} />
                                <BlockItem
                                    name={t('Outcome limit')}
                                    value={reward.initialCount === -1 ? t('unlimited') : reward.initialCount}
                                />
                                <BlockItem name={t('Awarded')} value={reward.givenCount} />
                                <BlockItem
                                    name={t('Left ')}
                                    value={reward.initialCount === -1 ? '—' : reward.initialCount - reward.givenCount}
                                />
                                <BlockItem name={t('Status')} value={getVisibilityText()} />
                                <BlockItem
                                    name={t('Probability')}
                                    value={REWARD_DATA[reward.weightFactor].getLabel()}
                                />
                            </Block>
                        </Blocks>
                        {!winners ? (
                            <Loader />
                        ) : (
                            <Blocks>
                                <Block title={t('Winners')}>
                                    {winners.content.length ? (
                                        <>
                                            {winners.content.map(winner => (
                                                <BlockItem key={winner} value={winner} />
                                            ))}
                                        </>
                                    ) : (
                                        <BlockItem value={t('No records yet')} />
                                    )}
                                </Block>
                            </Blocks>
                        )}
                        {!!winners && (
                            <Pagination
                                currentPage={winners.pageable.pageNumber}
                                totalPages={winners.totalPages}
                                onChange={fetchData}
                                isLoading={isLoading}
                            />
                        )}
                    </div>
                </div>
            </Modal>
        </>
    )
}

export default Details
